import React from 'react';
import {Icon, Link, Logo} from 'components';
import {Primary} from '.';
import {config} from 'helpers';
import {reset} from 'store/calendar';
import css from './navigation.module.scss';

export function Navigation() {
  return (
    <div className={css.container}>
      <Link className={css.logo} to="/today/" onClick={reset}>
        <Logo />
        <Logo.Text className={css.logoText} />
      </Link>
      <div className={css.menuContainer}>
        <Primary />
      </div>
      <footer className={css.footer}>
        {config.uat && <p className="danger bold lead"><Icon name="alert" /> development build</p>}
        <p>© { new Date().getFullYear() } { config.appName }, Inc.</p>
      </footer>
    </div>
  );
}
